import type { ActionHandler } from '../types'

export const handleInfectWound: ActionHandler<'INFECT_WOUND'> = async (ctx, payload) => {
  const { data: old } = await ctx.supabase
    .from('character_injuries')
    .select('is_infected, infection_hr, body_location')
    .eq('id', payload.injury_id)
    .single()

  if (!old) throw new Error('Injury not found')

  const { error } = await ctx.supabase
    .from('character_injuries')
    .update({ is_infected: true, infection_hr: payload.infection_hr })
    .eq('id', payload.injury_id)

  if (error) throw error

  const effects = []
  if (!old.is_infected) {
    effects.push({
      character_id: ctx.characterId,
      target_table: 'character_injuries',
      target_row_id: payload.injury_id,
      target_field: 'is_infected',
      operation: 'UPDATE' as const,
      old_value: false,
      new_value: true,
    })
  }
  effects.push({
    character_id: ctx.characterId,
    target_table: 'character_injuries',
    target_row_id: payload.injury_id,
    target_field: 'infection_hr',
    operation: 'UPDATE' as const,
    old_value: old.infection_hr,
    new_value: payload.infection_hr,
  })

  return {
    effects,
    label: `Infection: ${old.body_location} wound (HR ${payload.infection_hr})`,
    undoPolicy: 'undoable',
  }
}
